module.exports = __webpack_public_path__ + "img/helper.76bc9c54.jpg";